import makeCrud from '@/store/site/localization/crud'
const module = makeCrud('manager_campaign')
module.actions.previewAudience = async function (_, { segment_id }) {
    const res = await this._vm.axios.post(this._vm.endpoint.get('manager_campaign_preview'), { segment_id })
    return res.data
}
module.actions.send = async function (_, { id }) {
    const res = await this._vm.axios.post(this._vm.endpoint.get('manager_campaign') + '/' + id + '/send')
    return res.data
}
export default module
